import { MaintenanceWindowPatchManagementVendorProductSelectorGzDataProvider } from '../dataProvider/MaintenanceWindowPatchManagementVendorProductSelectorGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class MaintenanceWindowPatchManagementVendorProductSelectorDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, MaintenanceWindowPatchManagementVendorProductSelectorGzDataProvider);
  }
}
